import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import BenefitDefault from "ComponentsUI/Benefit/Components/BenefitDefault";
import Container from "reactstrap/lib/Container";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";
import { inject } from "mobx-react";

const styles = (theme) => ({
	root: {
		backgroundColor: "transparent",
		marginTop: "60px",
		paddingBottom: "60px",
	},
	noTranslate: {
		transform: "translateY(0)",
		marginBottom: "0",
	},
	withoutTopMargin: {
		marginTop: "0 !important",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			paddingBottom: "40px",
			marginTop: "40px",
		},
		noTranslate: {
			marginTop: "40px",
			marginBottom: "0px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			paddingBottom: "20px",
		},
	},
	[`@media (min-width: ${theme.media.xs}) and (max-width: ${theme.media.sm})`]: {
		root: {
			display: "none",
			marginBottom: 0,
			paddingBottom: 0,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		noTranslate: {
			transform: "translateY(0)",
			marginBottom: "0",
			paddingBottom: "40px",
		},
	},
	[`@media (max-width: ${theme.media.xs})`]: {
		root: {
			display: "none",
			marginBottom: 0,
			paddingBottom: 0,
		},
	},
});

const Wrapper = ({ children, classes, noTranslate, withoutTopMargin }) => {
	const className = classNames(classes.root, {
		[classes.noTranslate]: noTranslate,
		[classes.withoutTopMargin]: withoutTopMargin,
	});
	return (
		<Container>
			<div className={className}>{children}</div>
		</Container>
	);
};

const ContainerWrapper = withStyles(styles)(Wrapper);

@inject("ApplicationModel")
export default class BenefitsLayout extends React.Component {
	render() {
		const {
			noTranslate,
			ApplicationModel: { text },
		} = this.props;
		return (
			<ContainerWrapper noTranslate={noTranslate} withoutTopMargin={this.props.withoutTopMargin}>
				<Row>
					<Col sm={4} md={4} lg={4} xsHidden={true}>
						<BenefitDefault
							header={text.TITLE_GARANTY}
							text={text.TEXT_GARANTY}
							backgroundColor={!this.props.colorless ? "orange" : null}
							marginBottomZero={true}
							icon={
								<span
									style={{
										fontSize: "48px",
									}}
									className="icon48 icon-laptop-1"
								/>
							}
						/>
					</Col>
					<Col sm={4} md={4} lg={4} xsHidden={true}>
						<BenefitDefault
							header={text.TITLE_HIGH_SPEED_LOW_PAY}
							text={text.TEXT_HIGH_SPEED_LOW_PAY}
							backgroundColor={!this.props.colorless ? "purple" : null}
							marginBottomZero={true}
							icon={
								<span
									style={{
										fontSize: "48px",
									}}
									className="icon48 icon-swap-vertical"
								/>
							}
						/>
					</Col>
					<Col sm={4} md={4} lg={4} xsHidden={true}>
						<BenefitDefault
							header={text.TITLE_NO_OVERPAY}
							text={text.TEXT_NO_OVERPAY}
							backgroundColor={!this.props.colorless ? "purple" : null}
							marginBottomZero={true}
							icon={
								<span
									style={{
										fontSize: "48px",
									}}
									className="icon48 icon-calendar-date"
								/>
							}
						/>
					</Col>
				</Row>
			</ContainerWrapper>
		);
	}
}
